// Point d'entrée du client : démarre le magasin local, puis affiche l'application.
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { registerSW } from 'virtual:pwa-register';
import { App } from './App';
import { magasin } from './donnees/magasin';
import './style/base.css';
import './style/code.css';
import './style/disposition.css';
import './style/ecrans.css';

// Le service worker met la coquille en cache (R-OFF-01) et se met à jour tout seul.
registerSW({ immediate: true });

void magasin.demarrer();

createRoot(document.getElementById('racine')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
